class ProductShowcaseComponent extends HTMLElement {
    connectedCallback() {
        this.initVariantButtons();
        this.initPlanPicker();
    }

    slideCarouselToVariantMedia(featuredMediaId) {
        const carousel = this.querySelector('product-carousel');
        if (!featuredMediaId || !carousel || !carousel.swiperInstance) return;
        try {
            const mediaId = String(featuredMediaId);
            const slides = carousel.swiperInstance.slides;
            const slideIndex = Array.prototype.findIndex.call(
                slides,
                function (slide) {
                    return slide.querySelector(
                        '[data-media-id="' + mediaId + '"]'
                    );
                }
            );
            if (slideIndex < 0) return;
            const slideSpeed =
                parseInt(carousel.getAttribute('slide-speed'), 10) || 300;
            carousel.swiperInstance.slideTo(slideIndex, slideSpeed);
        } catch (_err) {
            /* ignore */
        }
    }

    initPlanPicker() {
        const picker = this.querySelector('.cspp');
        if (!picker) return;

        const form = this.querySelector('form.form');
        let planInput = null;

        if (form) {
            planInput = document.createElement('input');
            planInput.type = 'hidden';
            planInput.name = 'selling_plan';
            form.appendChild(planInput);
        }

        const activate = (group) => {
            picker.querySelectorAll('.cspp__group').forEach((g) => {
                g.classList.remove('is-active');
                const dot = g.querySelector('.cspp__radio-dot');
                if (dot) dot.classList.remove('is-checked');
            });
            group.classList.add('is-active');
            const dot = group.querySelector('.cspp__radio-dot');
            if (dot) dot.classList.add('is-checked');
            if (planInput) planInput.value = group.getAttribute('data-plan-id') || '';
        };

        const initial = picker.querySelector('.cspp__group.is-active');
        if (initial && planInput) planInput.value = initial.getAttribute('data-plan-id') || '';

        picker.querySelectorAll('.cspp__group').forEach((g) => {
            g.addEventListener('click', () => activate(g));
        });
    }

    initVariantButtons() {
        const variantBtns = this.querySelectorAll('[data-variant-id]');
        if (!variantBtns.length) return;

        variantBtns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const variantId = btn.getAttribute('data-variant-id');

                variantBtns.forEach((b) => {
                    b.classList.remove('is-active');
                });
                btn.classList.add('is-active');

                this.querySelectorAll('input[name="id"]').forEach((input) => {
                    input.disabled = false;
                    input.value = variantId;
                });

                const featuredMediaId = btn.getAttribute(
                    'data-featured-media-id'
                );
                this.slideCarouselToVariantMedia(featuredMediaId);
            });
        });
    }
}

customElements.get('product-showcase-component') ||
    customElements.define(
        'product-showcase-component',
        ProductShowcaseComponent
    );
